require('./DeleteChoreConfirmation.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');

// @ components
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const { OPENYOUNG_CHORE_DELETED, DATE_FORMAT_DAY_MONTH_SHORT, EURO_TEXT } = require('constants/index');

class DeleteChore extends React.Component {
    constructor(props) {
        super(props);
        this.handleDeleteChoreClick = this.handleDeleteChoreClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.createList = this.createList.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancel() {
        const { cardId } = this.props.match.params;
        this.props.history.push(`/myprofile/cards/${cardId}/chores`);
    }

    handleDeleteChoreClick() {
        const { openYoungCardChores, match: { params: { choreAssignmentId } }, updateChoreStatus } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const choreStatusDetails = {
            choreAssignmentId: choreAssignmentId,
            confirmationComment: '',
            choreStatusId: OPENYOUNG_CHORE_DELETED,
            reward: choreDetail.get('reward',0)
        }
        updateChoreStatus(choreStatusDetails);
    }

    isReady() {
        return false;
    }

    buildErrorWizard(immCard) {
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('deleteChore-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('deleteChore-errorTitle')}
                    mainButton={mainButton}
                >
                    <div className="delete-chore-confirmation__error-body">
                        <p className="col-md-6">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium"/>
                        </p>
                        <p className="delete-chore-confirmation__error-sub-message col-md-6">
                            <FormattedText
                                value="deleteChore-errorBodyText"
                            />
                        </p>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildSuccessWizard(immCard) {
        const { openYoungCardChores } = this.props;
        const choreDetail = openYoungCardChores.get('choreDetail');
        const nameOfTask = formatText(`openYoungCardChores-task${choreDetail.getIn(['chore','choreId'])}`);
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('deleteChore-backToCard', [cardAlias]).toUpperCase();
        const cardId = immCard.get('cardId');
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardSuccess
                    successMessage={formatText('deleteChore-successTitle')}
                    mainButton={mainButton}
                >
                    <div className="delete-chore-confirmation__success-body">
                        <div className="col-md-6">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium"/>
                        </div>
                        <p className="delete-chore-confirmation__success-sub-message col-md-6">
                            <FormattedText
                                value="deleteChore-successBodyText"
                                injectedStrings={[nameOfTask]}
                            />
                        </p>
                    </div>
                </WizardSuccess>
            </div>
        );
    }

    createList(list){
        return  list.map((item, key) => {
            if(item.value && item.value!= " "){
                return(
                    <OKInformativeListItem
                        className={"delete-chore-confirmation__list-item"}
                        key={key}
                        title={item.label}
                        bodyText={item.value}
                        bodyWordBreak={false}
                    />
                )
            }
        });
    }

    render() {
        const {
            immCards,
            openYoungCardChores,
            openYoungCardChoreStatusUpdateInfo,
            match: { params: { cardId } }
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const contentTitle = formatText('deleteChore-contentTitle');
        const immChoreDetails = openYoungCardChores.get('choreDetail');
        const currency = formatCurrency(EURO_TEXT);
        const reward = getFormattedString({ amount: immChoreDetails.get('reward'), currency });

        let block;

        const items = [
            {
                label: formatText('deleteChore-chore'),
                value: formatText(`openYoungCardChores-task${immChoreDetails.getIn(['chore','choreId'])}`)
            },
            {
                label: formatText('deleteChore-state'),
                value: formatText(`openYoungCardChores-status${immChoreDetails.getIn(['choreStatus','choreStatusId'])}`)
            },
            {
                label: formatText('deleteChore-selectedEndDate'),
                value: moment(immChoreDetails.get('endDate')).format(DATE_FORMAT_DAY_MONTH_SHORT)
            },
            {
                label: formatText('deleteChore-amount'),
                value: reward
            },
            {
                label: formatText('deleteChore-repetitions'),
                value: immChoreDetails.get('repeatTask') || 'No repetir'
            },
            {
                label: formatText('deleteChore-concept'),
                value: immChoreDetails.getIn(['comments','choreAssignmentComment'])
            },
            {
                label: formatText('deleteChore-childComment'),
                value: immChoreDetails.getIn(['comments','childComment'])
            },
            {
                label: formatText('deleteChore-choreConfirmationComment'),
                value: immChoreDetails.getIn(['comments','choreConfirmationComment'])
            }
        ];

        if (openYoungCardChoreStatusUpdateInfo && openYoungCardChoreStatusUpdateInfo.get('submitSuccessful')) {
            block = this.buildSuccessWizard(immCard);
        } else if (openYoungCardChoreStatusUpdateInfo && openYoungCardChoreStatusUpdateInfo.get('submitError')) {
            block = this.buildErrorWizard(immCard);
        } else {
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

            block = (
                <ContentBox id="deleteChore" smallTitle={true}>
                    <div>
                        <PreLeaveModalComponent
                            acceptText={acceptText}
                            confirmationMessage={confirmationMessage}
                            confirmationTitle={confirmationTitle}
                            cancelText={cancelText}
                            isReady={this.isReady}
                        />

                        <h1 className="delete-chore-confirmation__title">{contentTitle}</h1>

                        <OKInformativeList columns={3}>
                            {this.createList(items)}
                        </OKInformativeList>

                        <div className="delete-chore-confirmation__separator"/>
                        <footer className="delete-chore-confirmation__button text-right">
                            <div className="pull-left">
                                <OKButton modifier="link-ghost" onClick={this.handleCancel}>
                                    <FormattedText value="common-cancel" />
                                </OKButton>
                            </div>
                            <OKButton
                                onClick={this.handleDeleteChoreClick}
                                loading={openYoungCardChoreStatusUpdateInfo.get('isFetching')}
                            >
                                <FormattedText value="deleteChore-confirmButtonText"/>
                            </OKButton>
                        </footer>
                    </div>
                </ContentBox>
            );
        }

        return block;
    }
}

DeleteChore.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object,
    openYoungCardChores: PropTypes.object.isRequired,
    match: PropTypes.object,
    updateChoreStatus: PropTypes.func.isRequired
};

module.exports = withRouter(DeleteChore);
